import React from "react";
import { themeColor } from "@core/Styles";
import { CardStyleInterpolators, createStackNavigator } from "@react-navigation/stack";
import { StackScreenRenderAll } from "~/screens/Core/Navigator";
import { LoginScene } from "../Login/LoginScene";

const LoginStack = createStackNavigator();

export function LoginStackScreen(): JSX.Element {
  return (
    <LoginStack.Navigator
      screenOptions={{
        headerTintColor: themeColor.mainText,
        headerStyle: {
          backgroundColor: themeColor.bar,
          shadowColor: "transparent",
          shadowOpacity: 0,
          elevation: 0,
        },
        headerBackTitleVisible: false,
        gestureEnabled: true,
        gestureDirection: "horizontal",
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
      }}
      headerMode="float"
    >
      {/* {StackScreenRender(LoginStack.Screen, LoginScene)}
      {StackScreenRender(LoginStack.Screen, Detail2Scene)} */}
      {StackScreenRenderAll(LoginStack.Screen, LoginScene)}
    </LoginStack.Navigator>
  );
}
